import PasswordUsersUpdate from './PasswordUsersUpdate';

export default PasswordUsersUpdate;